export const isImageUrl = (value: string): boolean => /^(https?:\/\/|\/)/.test(value);
